//项目
const projectBox          = () => import('@/components/project/projectBox');
const projectList         = () => import('@/components/project/projectList');
const addProject          = () => import('@/components/project/project/addProject');
const editProject         = () => import('@/components/project/project/editProject');
const projectInfo         = () => import('@/components/project/projectInfo');
const versionList         = () => import('@/components/project/version/versionList');
const addVersion          = () => import('@/components/project/version/addVersion');
const editVersion         = () => import('@/components/project/version/editVersion');




export default{
    path: '/projectBox',
    name: 'projectBox',
    component: projectBox,
    children: [
        { path: 'projectList', component: projectList, name: 'projectList' }, 
        { path: 'projectInfo', component: projectInfo, name: 'projectInfo' },       
        { path: 'addProject', component: addProject, name: 'addProject' },
        { path: 'editProject', component: editProject, name: 'editProject' },        
        { path: 'versionList', component: versionList, name: 'versionList' },        
        { path: 'addVersion', component: addVersion, name: 'addVersion' },        
        { path: 'editVersion', component: editVersion, name: 'editVersion' },        
    ]
}



// WEBPACK FOOTER //
// ./src/router/routes/project.js